import React from "react";
import { Link } from "react-router-dom";
import { BROWSER_ROUTES } from "@constants/browser.routes";
import { SIDEBAR_EXPANDED_WIDTH_PX } from "@config/theme/tokens";
import { getCopyrightText } from "@components/Footer/utils/getCopyright";
import { useTranslation } from "react-i18next";
import { ENV } from "@config/env";

export const Footer: React.FC = () => {
	const { t } = useTranslation();
	return (
		<footer
			className="flex items-center justify-between border-t bg-white px-8 py-4 text-sm"
			style={{ marginLeft: `${SIDEBAR_EXPANDED_WIDTH_PX}px` }}>
			<div className="text-gray-500">{getCopyrightText(t("psdaCommon.footer.copyright"), t("common.projectTitle"))}{ENV.VERSION && <span className="ml-2 text-gray-400">{ENV.VERSION}</span>}</div>
			<div className="space-x-2">
				<Link to={BROWSER_ROUTES.PRIVACY_POLICY} className="text-primary hover:underline">
					{t("psdaCommon.footer.privacyPolicy")}
				</Link>
				<span className="text-gray-400">|</span>
				<Link to={BROWSER_ROUTES.TERMS_AND_CONDITIONS} className="text-primary hover:underline">
					{t("psdaCommon.footer.termsOfService")}
				</Link>
			</div>
		</footer>
	);
};
